<template>
    <div v-if="err.length">
        <div v-for="error in err" class="alert alert-danger d-flex justify-content-between" role="alert">
            <span v-html="error"></span>
            <button type="button" class="btn-close" @click="dismiss"></button>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormErrorAlerts",
    props: ['errors'],
    data() {
        return {
            err: []
        };
    },
    watch: {
        errors: {
            handler(newErrors) {
                this.err = newErrors;
            },
            immediate: true
        }
    },
    methods: {
        dismiss() {
            this.err = [];
        }
    }
}
</script>
